import { render } from "./App.vue?vue&type=template&id=0428adec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0428adec&lang=less"

import exportComponent from "D:\\webSpace\\南昌县教育馆\\ncxjyg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__